import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";
import { categories, MAIN_SITE_URL } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-background-200 bg-primary-950 text-background-50">
      <div className="mx-auto w-full px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-white">
                <i className="ri-file-list-3-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold">{t("siteName")}</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-300">
              {t("footerTagline")}
            </p>
            <div className="mt-5">
              <LanguageSwitcher />
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-background-200">
              {t("footerQuickLinks")}
            </h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <Link to="/" className="text-background-300 transition-colors hover:text-white">
                  {t("footerHome")}
                </Link>
              </li>
              <li>
                <Link
                  to="/usfans-spreadsheet-guide"
                  className="text-background-300 transition-colors hover:text-white"
                >
                  {t("footerGuide")}
                </Link>
              </li>
              <li>
                <a
                  href={MAIN_SITE_URL}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-background-300 transition-colors hover:text-white"
                >
                  {t("ctaMainSite")}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-background-200">
              {t("footerCategories")}
            </h4>
            <ul className="mt-4 grid grid-cols-1 gap-2 text-sm">
              {categories.slice(0, 6).map((c) => (
                <li key={c.key}>
                  <a
                    href={c.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-background-300 transition-colors hover:text-white"
                  >
                    {t(`categories.${c.key}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-background-200">
              {t("footerLegal")}
            </h4>
            <p className="mt-4 text-xs leading-relaxed text-background-400">{t("disclaimer")}</p>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 text-xs text-background-400 sm:flex-row sm:items-center">
          <p>
            © {new Date().getFullYear()} {t("copyright")}
          </p>
          <p>{t("externalNote")}</p>
        </div>
      </div>
    </footer>
  );
}